/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1ProgrammeScheduleItem
 */
export interface V1ProgrammeScheduleItem {
    /**
     *
     */
    id?: string
    /**
     *
     */
    kind?: V1ProgrammeScheduleItemKindEnum
    /**
     *
     */
    lessonId?: string
}

/**
 * @export
 */
export const V1ProgrammeScheduleItemKindEnum = {
    Workout: 'workout',
    Recovery: 'recovery'
} as const
export type V1ProgrammeScheduleItemKindEnum =
    (typeof V1ProgrammeScheduleItemKindEnum)[keyof typeof V1ProgrammeScheduleItemKindEnum]

/**
 * Check if a given object implements the V1ProgrammeScheduleItem interface.
 */
export function instanceOfV1ProgrammeScheduleItem(
    value: object
): value is V1ProgrammeScheduleItem {
    return true
}

export function V1ProgrammeScheduleItemFromJSON(
    json: any
): V1ProgrammeScheduleItem {
    return V1ProgrammeScheduleItemFromJSONTyped(json, false)
}

export function V1ProgrammeScheduleItemFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1ProgrammeScheduleItem {
    if (json == null) {
        return json
    }
    return {
        id: json['id'] == null ? undefined : json['id'],
        kind: json['kind'] == null ? undefined : json['kind'],
        lessonId: json['lessonId'] == null ? undefined : json['lessonId']
    }
}

export function V1ProgrammeScheduleItemToJSON(
    json: any
): V1ProgrammeScheduleItem {
    return V1ProgrammeScheduleItemToJSONTyped(json, false)
}

export function V1ProgrammeScheduleItemToJSONTyped(
    value?: V1ProgrammeScheduleItem | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        kind: value['kind'],
        lessonId: value['lessonId']
    }
}
